// Per-device settings, persisted in localStorage (NOT tied to the user account — they live on this
// browser/device only). Read by device-settings_compiler.js to apply settings and by the settings
// page to bind its controls. Values are stored as JSON, so booleans round-trip correctly.

const PREFIX = 'device_setting:';

export function getDeviceSetting(key, fallback = null) {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch (error) {
    // localStorage unavailable (private mode / disabled) or corrupt value — fall back.
    return fallback;
  }
}

export function setDeviceSetting(key, value) {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (error) {
    // localStorage unavailable — the setting simply won't persist on this device.
  }
}

// Name of the same-tab DOM event dispatched when a setting changes, so anything applying the
// setting (e.g. the env-banner) can react live without a reload. (The native `storage` event only
// fires in *other* tabs.)
export const deviceSettingEvent = (key) => `device-setting:${key}`;
